import { Button } from "@mui/material";
import jwt_decode from "jwt-decode";
import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import strings from "../../config/localization";
import { routes } from "./routes";
import "./sidebar.css";

const Sidebar = () => {
  const location = useLocation();
  const pathName = location?.pathname?.split("/");
  const accessToken = localStorage.getItem("accessToken")!;
  const navigate = useNavigate();

  const [lang, setLanguage] = React.useState("");
  const [prevLang, setPrevLang] = React.useState("");
  useEffect(() => {
    const language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    setLanguage(language || "en");
    setPrevLang(language || "en");
    strings.setLanguage(language || "en");
  }, []);

  useEffect(() => {
    console.log(lang, prevLang);
    if (lang !== prevLang) {
      setPrevLang(lang);
      strings.setLanguage(lang);
      localStorage.setItem("language", lang);
      window.location.reload();
      console.log("Reloading");
    }
  }, [lang]);

  function isPermissionExists(accessToken: string, permission: string) {
    if (accessToken) {
      const payload: any = jwt_decode(accessToken);
      for (let i = 0; i < payload?.roles?.length; i++) {
        if (payload?.roles[i]?.permissions?.includes(permission)) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  function isRoleExists(accessToken: string, roles: string[]) {
    const payload: any = jwt_decode(accessToken);
    const allRoles = new Set(payload.roles.map((e: any) => e.name));

    for (let i = 0; i < roles.length; i++) {
      if (allRoles.has(roles[i])) {
        return true;
      }
    }
    return false;
  }

  function getUsername(accessToken: string) {
    if (accessToken) {
      const payload: any = jwt_decode(accessToken);
      return payload.userName;
    }
    return "";
  }

  const adminMenu = () => (
    <div>
      <img
        src={require("./logo.png")}
        width={60}
        height={60}
        className="logo"
        alt="logo"
      />
      <nav>
        <ul>
          {routes.map((data, index) => {
            if ("permission" in data) {
              if (
                data["permission"] === undefined ||
                data["permission"] === "" ||
                !isPermissionExists(accessToken, data["permission"])
              ) {
                return <></>;
              }
              return (
                <li key={index}>
                  <Link to={data.path} id={data.layout}>
                    <p
                      className={
                        pathName[1] === data.layout
                          ? "pathNameActive"
                          : "pathName"
                      }
                    >
                      {data.name}
                    </p>
                  </Link>
                </li>
              );
            } else {
              // neither permission nor role is specfied. Show the item.
              return (
                <li key={index}>
                  <Link to={data.path}>
                    <p
                      className={
                        pathName[1] === data.layout
                          ? "pathNameActive"
                          : "pathName"
                      }
                    >
                      {data.name}
                    </p>
                  </Link>
                </li>
              );
            }
          })}
        </ul>
      </nav>
    </div>
  );

  return (
    <div
      id="style-3"
      style={{
        width: "160px",
        height: "100vh",
        backgroundColor: "rgb(0, 114, 187)",
        float: "left",
        position: "fixed",
      }}
    >
      <div
        className="side_menu"
        style={{
          display: "block",
          opacity: "1",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        {adminMenu()}
        <div className="userText">
          <b>User:</b> {getUsername(accessToken!)}
        </div>
        <br></br>
        <Button
          variant="contained"
          className="m-auto d-block"
          onClick={() => {
            localStorage.clear();
            navigate("/login");
          }}
        >
          Logout
        </Button>
        <p className="lanText">Change Language</p>
        <select
          className="languageChange"
          value={lang}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option>en</option>
          <option>gu</option>
        </select>
      </div>
      <div
        style={{
          display: "block",
          opacity: "1",
          height: "100vh",
          overflowY: "scroll",
        }}
      ></div>
    </div>
  );
};

export default Sidebar;
